import { HttpClient } from 'common/services/http-client.service';
import {
    ApplicationFeature,
    CreateRoleDto,
    EditRoleDto,
    RoleCreateEditResponse,
    RoleDeleteResponse,
    RoleDto,
    RoleFeature,
    Roles
} from '../models/role-management.model';
import { IErrorApiResponse } from 'common/models/api-service/error-response.model';
import { ApiResult } from 'common/models';
import roleManagementApiConfig from './role-management.config';

export class RoleManagementService extends HttpClient {
    /** keeping this below call to add pagination in this call */
    // public static async getAllRoles(
    //     payload: PagedRequest
    // ): Promise<ApiResult<RoleDto | IErrorApiResponse> | undefined> {
    //     return RoleManagementService.invokeApi<Roles | IErrorApiResponse>(
    //         roleManagementApiConfig.fetchAllApplicationRoles(payload)
    //     );
    // }

    public static async getAllRoles(): Promise<ApiResult<RoleDto[]> | undefined> {
        return RoleManagementService.invokeApi<Roles | IErrorApiResponse>(
            roleManagementApiConfig.fetchAllApplicationRoles()
        );
    }

    public static async getAllFeatures(
        roleId: string
    ): Promise<ApiResult<RoleFeature[]> | undefined> {
        return RoleManagementService.invokeApi<RoleFeature>(
            roleManagementApiConfig.fetchApplicationFeatures(roleId)
        );
    }

    public static async createRole(
        payload: CreateRoleDto
    ): Promise<ApiResult<RoleCreateEditResponse> | undefined> {
        return await this.invokeApi(roleManagementApiConfig.createApplicationRole(payload));
    }

    public static async updateRole(
        payload: EditRoleDto
    ): Promise<ApiResult<RoleCreateEditResponse> | undefined> {
        return await this.invokeApi(roleManagementApiConfig.updateApplicationRole(payload));
    }

    public static async deleteRole(
        roleId: string
    ): Promise<ApiResult<RoleDeleteResponse> | undefined> {
        return await this.invokeApi(roleManagementApiConfig.deleteApplicationRole(roleId));
    }
}
